import React, { FC } from 'react';
import { AdditionalType } from '../../../model/interfaces';
import { FinishedTournamentScheme } from '../../finishedTournaments/finishedAdditional/finishedTournamentScheme/finishedTournamentScheme';
import FinishedTournamentWinner from '../../finishedTournaments/finishedAdditional/finishedTournamentWinner/finishedTournamentWinner';
import { InProgressTournamentInfo } from './inProgressTournamentInfo/inProgressTournamentInfo';

type PropsType = {
  data: AdditionalType;
};

export const InProgressTournamentAdditional: FC<PropsType> = ({
  data,
}: PropsType) => {
  const info = {
    directorName: data.directorName,
    directorId: data.directorId,
    startTime: data.startTime,
    checkIn: data.checkIn,
    pairing: data.pairing,
    timeControl: data.timeControl,
    entryFee: data.entryFee,
    description: data.description,
    extraBonus: data.extraBonus,
  };

  const winners = [
    {
      amt: data.firstPrizeAmt,
      name: data.firstPrizeUsr,
    },
    {
      amt: data.secondPrizeAmt,
      name: data.secondPrizeUsr,
    },
    {
      amt: data.thirdPrizeAmt,
      name: data.thirdPrizeUsr,
    },
    {
      amt: data.fourthPrizeAmt,
      name: data.fourthPrizeUsr,
    },
  ];
  const idTourney = data.tourneyID;
  // const idTourney = data.tourneyID;

  return (
    <div className="progress-additional">
      {/* <div className="progress-additional__info"> */}
        <InProgressTournamentInfo info={info} />
        <FinishedTournamentWinner winners={winners} />
        <FinishedTournamentScheme idTourney={idTourney} />

        {/* <div className="progress-scheme">scheme</div>

        <div className="progress-button">buttons</div> */}
      </div>
    // </div>
  );
};
